module.exports = __webpack_public_path__ + "img/other_pay_credit_card.53a62d3e.svg";